import { PropsWithChildren, useMemo, useState } from 'react';

import { ScopeModel } from '../../../modules/Apps';
import { createNullableContext, useNullableContext } from '../../../utils/Context';
import { PopoverStateReturn } from '../../common/Drawer/Drawer.context';

interface ScopesTableContextValues {
  createScopeDrawerState: PopoverStateReturn;
  editScopeDrawerState: PopoverStateReturn;
  viewScopeDrawerState: PopoverStateReturn;
  editingScope?: ScopeModel;
  setEditingScope: (value?: ScopeModel) => void;
}

interface ScopesTableContextProviderProps {
  createScopeDrawerState: PopoverStateReturn;
  editScopeDrawerState: PopoverStateReturn;
  viewScopeDrawerState: PopoverStateReturn;
}

export const ScopesTableContext =
  createNullableContext<ScopesTableContextValues>('ScopesTableContext');

export const useScopesTableContext = () => useNullableContext(ScopesTableContext);

export const ScopesTableContextProvider = ({
  children,
  createScopeDrawerState,
  editScopeDrawerState,
  viewScopeDrawerState,
}: PropsWithChildren<ScopesTableContextProviderProps>) => {
  const [editingScope, setEditingScope] = useState<ScopeModel | undefined>();

  const value = useMemo(
    () => ({
      createScopeDrawerState,
      editScopeDrawerState,
      viewScopeDrawerState,
      editingScope,
      setEditingScope,
    }),
    [createScopeDrawerState, editScopeDrawerState, editingScope, viewScopeDrawerState],
  );

  return <ScopesTableContext.Provider value={value}>{children}</ScopesTableContext.Provider>;
};
